import {LabelInValue} from "common/form";
import React, {useContext} from "react";
import {useVeriflytTicketTemplateSelectApi, VeriflytTicketTemplateSelectApiContext} from "../state";
import {useTicketTemplatesQuery} from "../graphql";
import {Button, Col, List, Row} from "antd";
import AddItem from "./add-item";
import SelectPanelDrawer from "../select-panel-drawer";
import SelectPanel from "../select-panel";
import ListItem from "./list-item";
import {BASE_CLASS} from "./constants";
import './multi-select.style.less';

export interface VeriflytTicketTemplateMultiSelectProps {
    value?: LabelInValue[],
    selectedTds?: string[],
    disabledTicketTemplateIds?: string[],
    disabledMessage?: string,
    disabled?: boolean,
    onChange?: (selectedIds: LabelInValue[]) => void,
    noticeAlertText?: string
}

const VeriflytTicketTemplateMultiSelect: React.FC<VeriflytTicketTemplateMultiSelectProps> = (props) => {
    const ctx = useContext(VeriflytTicketTemplateSelectApiContext);
    const controlled = !!ctx;

    const value = props.value || [];

    const queryResult = useTicketTemplatesQuery({
        limit: 9999999
    });
    const _api = useVeriflytTicketTemplateSelectApi(
        queryResult?.data
    );

    const api = controlled ? ctx : _api;

    function handleRemove(item: LabelInValue){
        if (typeof props.onChange === 'function'){
            const newValue = value.filter(i => i.key !== item.key);
            props.onChange(newValue);
        }
    }

    function renderItem(item: LabelInValue){
        return (
            <ListItem value={item} onRemove={handleRemove} />
        )
    }

    function handleTicketTemplateSelected(ticketTemplateID: string, onScreenName: string){
        if (typeof props.onChange === 'function'){
            api.closePanel();
            props.onChange(
                [...value, { key: ticketTemplateID, label: onScreenName }]
            );
        }
    }

    let drawer: React.ReactNode = null;

    const items = value.map(renderItem) || null;

    const addItem = (
        <AddItem api={api} />
    )

    if (!controlled){
        drawer = (
            <SelectPanelDrawer
                title="Select a certification"
                visible={api.state.drawerOpen}
                onClose={api.closePanel}
                bodyStyle={{
                    padding: 0
                }}
                className="ant-drawer-flex"
                destroyOnClose
            >
                <SelectPanel
                    api={api}
                    onTicketTemplateSelected={handleTicketTemplateSelected}
                    disabledTicketTemplateIds={value.map(({ key }) => key)}
                    // disabledMessage={disabledMessage}
                    noticeAlertText={props.noticeAlertText}
                />
            </SelectPanelDrawer>
        )
    }

    return (
        <>
            <List header={addItem} bordered size="small" className={BASE_CLASS}>
                {items}
            </List>
            {drawer}
        </>
    )
}

export default VeriflytTicketTemplateMultiSelect;